import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const FileDisplayContainer = styled.div`
  display: flex;
  align-items: center;
  background: rgb(235, 235, 235);
  border: ${pxToRem(1)} solid #ccc;
  border-radius: ${pxToRem(16)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  position: relative;
  max-width: ${pxToRem(150)};
  width: ${pxToRem(87)};
  height: ${pxToRem(87)};

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: rgb(0, 0, 0);
    font-size: ${pxToRem(14)};
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover .tooltip {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const Tooltip = styled.div`
  visibility: hidden;
  opacity: 0;
  text-align: center;
  padding: ${pxToRem(4)} ${pxToRem(8)};
  font-size: ${pxToRem(12)};
  position: absolute;
  bottom: 80%; 
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  transition: opacity 0.3s ease;
`;

export const FileIcon = styled.img`
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  margin-bottom: ${pxToRem(8)};
`;

export const SpinnerIconContainer = styled.div`
  position: relative;
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  margin-bottom: ${pxToRem(8)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpinnerIcon = styled.div<{ $frames: string[] }>`
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  background-image: ${({ $frames }) => $frames.map((frame, index) => `url(${frame})`).join(", ")};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  animation: spinner-animation 0.8s steps(4, end) infinite;
  
  @keyframes spinner-animation {
    0% {
      background-image: url(${({ $frames }) => $frames[0]});
    }
    25% {
      background-image: url(${({ $frames }) => $frames[1]});
    }
    50% {
      background-image: url(${({ $frames }) => $frames[2]});
    }
    75% {
      background-image: url(${({ $frames }) => $frames[3]});
    }
    100% {
      background-image: url(${({ $frames }) => $frames[0]});
    }
  }
`;

export const ProgressPercent = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: ${pxToRem(10)};
  font-weight: 600;
  color: #fff;
  text-shadow: 0 0 ${pxToRem(2)} rgba(0, 0, 0, 0.8);
  z-index: 1;
  pointer-events: none;
`;

export const FileName = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: ${pxToRem(60)};
  text-align: center;
`;

export const RemoveFileButton = styled.button`
  position: absolute;
  top: ${pxToRem(4)};
  right: ${pxToRem(4)};
  background: none;
  border: none;
  color: #ff4d4f;
  font-size: ${pxToRem(16)};
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
